<template>
  <div class="element-input element-textarea" :class="{ disabled }">
    <div class="label">{{ label }}</div>
    <div class="body">
      <textarea
        v-model="model"
        :disabled="disabled"
        :placeholder="placeholder" 
        :style="{ 'border': valid ? 'none' : '1px solid #cc3232' }"
      />
    </div>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "disabled", "placeholder", 'validate' ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    },
    valid() {
      if (this.validate) {
        return this.value === '' ? false: true;
      }

      return true;
    }
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    }
  }

}
</script>
